module.exports = __webpack_public_path__ + "static/media/home.9e4b4519.mp4";